<template>
  <div class="block">
    <Sidebar />

    <router-view name="product" v-slot="{ Component }">
      <transition name="up" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'

export default {
  name: 'Product',

  components: {
    Sidebar
  },
}
</script>

<style>
</style>
